module.exports = __webpack_public_path__ + "img/sign.05e960c0.png";